const ownersLogoStyles = ({ theme }) => ({
  marginBottom: theme.spacing(2),
})

export default props =>
  Object.freeze({ ownersLogoStyles: ownersLogoStyles(props) })
